// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C10 preparation: full-width parties/dates/items, notes beside one draft total. */
.rcti-editor-shell .rcti-prepare-page .invoice-editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.rcti-editor-shell .rcti-prepare-page .invoice-editor-column {
  display: contents;
}
.rcti-editor-shell
  .rcti-prepare-page
  :is(.rcti-prepare-parties, .rcti-prepare-dates, .invoice-items-editor, .rcti-editor-settlement, .invoice-payment-card) {
  grid-column: 1 / -1;
}
.rcti-editor-shell .rcti-prepare-page .invoice-flow-card {
  min-width: 0;
  background: var(--surface-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
}
.rcti-editor-shell .rcti-prepare-page .invoice-flow-card h2 {
  font-size: var(--font-size-body-lg);
  font-weight: var(--font-weight-medium);
  margin: 0 0 var(--space-4);
}
.rcti-editor-shell .rcti-prepare-page {
  --rcti-field-label-gap: 6px;
}
.rcti-editor-shell
  .rcti-prepare-page
  .invoice-flow-card
  label:not(.rcti-prepare-declaration-check):not(.quotation-attachment-upload) {
  gap: var(--rcti-field-label-gap);
}
.rcti-editor-shell .rcti-prepare-page .figma-datepicker__label {
  margin-bottom: var(--rcti-field-label-gap);
  line-height: 18.2px;
}
.rcti-prepare-state {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  margin: var(--space-6) 0;
  font-size: var(--font-size-body-sm);
}
.rcti-prepare-state > div {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
}
.rcti-prepare-state > button {
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  padding: var(--space-3) var(--space-4);
  font: inherit;
}
.rcti-prepare-parties {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: var(--space-6);
  row-gap: var(--space-3);
}
.rcti-prepare-parties > h2,
.rcti-prepare-parties > .invoice-fields {
  grid-column: 1 / -1;
}
.rcti-prepare-parties .invoice-fields {
  align-items: start;
  margin: 0;
}
.rcti-prepare-agreement {
  display: grid;
  gap: var(--space-2);
  grid-column: 2;
  grid-row: 1 / span 2;
  align-content: start;
}
.rcti-prepare-parties .invoice-fields > label {
  grid-column: 1;
  grid-row: 1;
}
.rcti-prepare-contact {
  grid-column: 1;
  grid-row: 3;
  display: grid;
  gap: var(--space-2);
  align-self: start;
}
.rcti-prepare-parties > .invoice-fields {
  display: contents;
}
.rcti-prepare-parties > h2 {
  grid-row: 1;
}
.rcti-prepare-parties > .invoice-fields > label {
  grid-row: 2;
}
.rcti-prepare-parties .rcti-prepare-agreement {
  grid-row: 2 / span 2;
}
.rcti-editor-shell
  .rcti-prepare-page
  :is(.rcti-prepare-agreement, .rcti-prepare-contact)
  p {
  margin: 0;
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-prepare-buyer,
.rcti-prepare-declaration {
  grid-column: 1 / -1;
  margin: var(--space-2) 0 0;
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
.rcti-editor-shell .rcti-prepare-page a {
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
}
.rcti-editor-shell
  .rcti-prepare-page
  :is(.rcti-prepare-reference, .rcti-prepare-tools) {
  margin-top: var(--space-4);
  font-size: var(--font-size-body-sm);
}
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-reference {
  display: grid;
  gap: var(--space-4);
}
.rcti-prepare-reference h3,
.rcti-prepare-extra-note h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.rcti-editor-shell .rcti-prepare-page .invoice-items-editor {
  display: grid;
  gap: var(--space-4);
}
.rcti-editor-shell .rcti-prepare-page .invoice-item-heading,
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) 64px 120px 100px 96px 32px;
  gap: var(--space-3);
}
.rcti-editor-shell .rcti-prepare-page .invoice-item-heading {
  margin: 0;
  align-items: center;
  border-radius: var(--radius-sm);
  background: var(--surface-secondary);
  padding: var(--space-3) 0;
  font-size: var(--font-size-caption-md);
}
.rcti-editor-shell .rcti-prepare-page .invoice-item-heading > span:first-child {
  padding-left: var(--space-3);
}
.rcti-editor-shell .rcti-prepare-page .invoice-item-heading > span:nth-child(5) {
  text-align: right;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item {
  padding: var(--space-4) 0;
  border: 0;
  border-bottom: 1px solid var(--border-subtle);
  border-radius: 0;
  background: transparent;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-picker {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-description {
  grid-column: 1 / -1;
  grid-row: 2;
}
.rcti-editor-shell
  .rcti-prepare-page
  .invoice-edit-item
  > input[aria-label^="Quantity"] {
  grid-column: 2;
  grid-row: 1;
}
.rcti-editor-shell
  .rcti-prepare-page
  .invoice-edit-item
  > input[aria-label^="Unit price"] {
  grid-column: 3;
  grid-row: 1;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .rcti-line-tax {
  grid-column: 4;
  grid-row: 1;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > strong {
  grid-column: 5;
  grid-row: 1;
  align-self: center;
  text-align: right;
  font-size: var(--font-size-body-sm);
  font-family: var(--font-family-mono);
}
.rcti-editor-shell
  .rcti-prepare-page
  .invoice-edit-item
  .invoice-rcti-row-actions {
  grid-column: 6;
  grid-row: 1;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-type {
  grid-column: 1;
  grid-row: 3;
  width: 140px;
}
.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-value {
  grid-column: 1;
  grid-row: 3;
  margin-left: 152px;
  width: 140px;
}
.rcti-editor-shell .rcti-prepare-page .quotation-items-table-body.is-scrollable {
  overflow-y: auto;
  overscroll-behavior: contain;
}
.rcti-editor-shell .rcti-prepare-page
  :is([id^="rcti-prepare-"], #rcti-buyer-declaration) {
  scroll-margin-top: calc(var(--app-topbar-height, 64px) + var(--space-4));
}
.rcti-prepare-notes {
  grid-column: 1;
  grid-row: 4;
  display: grid;
  gap: var(--space-4);
}
.rcti-prepare-notes > section {
  padding: 0;
  border: 0;
  box-shadow: none;
  background: transparent;
}
.rcti-prepare-notes .invoice-notes-fields {
  grid-template-columns: 1fr;
}
.rcti-prepare-notes .quotation-attachment-summary {
  padding: var(--space-3);
}
.rcti-prepare-total {
  grid-column: 2;
  grid-row: 4;
  position: static !important;
  display: grid;
  gap: var(--space-3);
  padding: var(--space-6);
  background: var(--surface-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}
.rcti-prepare-total > .invoice-summary-card {
  border: 0;
  padding: 0;
  box-shadow: none;
}
.rcti-prepare-total > p {
  margin: 0;
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-draft-total-actions {
  display: grid;
  gap: var(--space-3);
  margin-top: var(--space-4);
}
.rcti-draft-total-actions > button {
  width: 100%;
}
@media (max-width: 1100px) {
  .rcti-editor-shell .rcti-prepare-page .invoice-item-heading,
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item {
    grid-template-columns: minmax(180px, 1fr) 56px 100px 84px 96px 32px;
  }
}
@media (max-width: 1100px) {
  .rcti-editor-shell .rcti-prepare-page .invoice-editor-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-prepare-notes,
  .rcti-prepare-total {
    grid-column: 1;
    grid-row: auto;
  }
  .rcti-prepare-parties {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-prepare-parties .rcti-prepare-agreement {
    grid-column: 1;
    grid-row: 4;
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-item-heading {
    display: none;
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-picker {
    grid-column: 1 / -1;
    grid-row: 1;
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-description {
    grid-row: 2;
  }
  .rcti-editor-shell
    .rcti-prepare-page
    .invoice-edit-item
    > input[aria-label^="Quantity"] {
    grid-column: 1;
    grid-row: 3;
  }
  .rcti-editor-shell
    .rcti-prepare-page
    .invoice-edit-item
    > input[aria-label^="Unit price"] {
    grid-column: 2;
    grid-row: 3;
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .rcti-line-tax {
    grid-column: 3;
    grid-row: 3;
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > strong {
    grid-column: 4;
    grid-row: 3;
    font-size: var(--font-size-caption-md);
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-type {
    grid-column: 1 / 3;
    grid-row: 4;
    width: auto;
  }
  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-value {
    grid-column: 3 / 5;
    grid-row: 4;
    margin: 0;
    width: 100%;
  }
  .rcti-editor-shell
    .rcti-prepare-page
    .invoice-edit-item
    .invoice-rcti-row-actions {
    grid-column: 4;
    grid-row: 5;
  }
}

.rcti-editor-shell .rcti-prepare-page .rcti-prepare-total {
  grid-column: 2;
  grid-row: 4;
  max-height: none;
  overflow: visible;
  position: static;
}
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-notes {
  grid-column: 1;
  grid-row: 4;
}
@media (max-width: 1100px) {
  .rcti-editor-shell .rcti-prepare-page .rcti-prepare-total,
  .rcti-editor-shell .rcti-prepare-page .rcti-prepare-notes {
    grid-column: 1;
    grid-row: auto;
  }
}
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-notes > section,
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-total > section {
  border: 0;
  box-shadow: none;
  padding: 0;
  background: transparent;
}
.rcti-editor-shell .rcti-prepare-page p {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-editor-shell
  .rcti-prepare-page
  .rcti-prepare-contact
  > :is(strong, span) {
  font-size: var(--font-size-body-sm);
}
.rcti-editor-shell
  .rcti-prepare-page
  .rcti-prepare-notes
  .invoice-notes-fields {
  grid-template-columns: minmax(0, 1fr);
}
.rcti-prepare-tax-rate {
  display: flex;
  gap: var(--space-4);
  align-items: end;
}
.rcti-prepare-tax-rate > label {
  width: min(300px, 100%);
}
.rcti-prepare-tax-rate p {
  flex: 1 1;
  margin: 0 0 var(--space-3);
}
.rcti-prepare-extra-note { display: grid; gap: var(--space-3); }
@media (max-width: 1100px) {
  .rcti-prepare-tax-rate {
    flex-direction: column;
    align-items: start;
  }
  .rcti-prepare-tax-rate p {
    margin: 0;
  }
}
.rcti-editor-shell .rcti-prepare-page .invoice-editor-header p span {
  color: var(--text-secondary);
}
.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts {
  display: flex;
  grid-column: 1 / -1;
  grid-row: 3;
  gap: var(--space-3);
}
.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts > label {
  width: 148px;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: start;
  gap: var(--rcti-field-label-gap);
  font-size: var(--font-size-caption-md);
}
.rcti-editor-shell .rcti-prepare-page .rcti-adjustment-card > textarea {
  margin-top: var(--rcti-field-label-gap);
}
.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts .discount-type,
.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts .discount-value {
  grid-column: 1;
  width: 100%;
  min-width: 0;
  max-width: none;
  margin: 0;
}
@media (max-width: 1100px) {
  .rcti-editor-shell .rcti-prepare-page .rcti-line-discounts {
    grid-row: 4;
  }
  .rcti-editor-shell .rcti-prepare-page .rcti-line-discounts > label {
    width: calc(50% - var(--space-2));
  }
}
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check { display: inline-flex; align-items: flex-start; gap: var(--space-2); margin-right: var(--space-2); font-size: var(--font-size-body-sm); line-height: 1.65; }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check input { width: 16px; height: 16px; flex: 0 0 16px; margin: 3px 0 0; accent-color: var(--interactive-default); }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-contact { min-width: 0; }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-address { max-width: min(100%, 44ch); white-space: normal; overflow-wrap: anywhere; word-break: normal; }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration { display: grid; grid-template-columns: minmax(0,1fr) auto; align-items: start; gap: var(--space-3); }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check { display: flex; flex-direction: row; align-items: flex-start; margin: 0; min-width: 0; font-weight: var(--font-weight-regular); }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check > span { min-width: 0; }
.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration > .rcti-business-eligibility-action { align-self: start; line-height: 1.65; }
@media(max-width:800px) { .rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration { grid-template-columns: minmax(0,1fr); } .rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration > .rcti-business-eligibility-action { margin-left: 24px; } }

.rcti-editor-shell .rcti-business-eligibility-action {
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--interactive-default);
  font: inherit;
  line-height: 1.65;
  text-align: left;
  cursor: pointer;
}
.rcti-editor-shell .rcti-business-eligibility-action:disabled {
  color: var(--text-disabled, var(--text-secondary));
  opacity: 0.5;
  cursor: not-allowed;
}
.rcti-supplier-eligibility-check { display: flex; align-items: center; gap: var(--space-3); }
.rcti-supplier-eligibility-check svg { flex-shrink: 0; }
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiPrepare.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;;;EAIE,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;AACf;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;;;;EAIE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA;;;EAGE,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,0BAA0B;EAC1B,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,oEAAoE;EACpE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,6CAA6C;EAC7C,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;;;;EAIE,cAAc;EACd,WAAW;AACb;AACA;;;;EAIE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,oCAAoC;AACtC;AACA;;;;EAIE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;;EAEE,wEAAwE;AAC1E;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,sCAAsC;EACtC,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE;;IAEE,mEAAmE;EACrE;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;;IAEE,cAAc;IACd,cAAc;EAChB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,gDAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;;;IAIE,cAAc;IACd,WAAW;EACb;EACA;;;;IAIE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;IACX,sCAAsC;EACxC;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;EACb;EACA;;;;IAIE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE;;IAEE,cAAc;IACd,cAAc;EAChB;AACF;AACA;;EAEE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;;;;EAIE,mCAAmC;AACrC;AACA;;;;EAIE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,0BAA0B;AAC5B;AACA,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;AAC/D;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,iCAAiC;EACnC;AACF;AACA,wEAAwE,oBAAoB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,4BAA4B,EAAE,mCAAmC,EAAE,iBAAiB,EAAE;AAClO,8EAA8E,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,wCAAwC,EAAE;AACpL,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,0BAA0B,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAC5J,kEAAkE,aAAa,EAAE,yCAAyC,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACrK,wEAAwE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS,EAAE,YAAY,EAAE,uCAAuC,EAAE;AACvM,+EAA+E,YAAY,EAAE;AAC7F,sGAAsG,iBAAiB,EAAE,iBAAiB,EAAE;AAC5I,0BAA0B,kEAAkE,oCAAoC,EAAE,EAAE,sGAAsG,iBAAiB,EAAE,EAAE;;AAE/P;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kDAAkD;EAClD,YAAY;EACZ,mBAAmB;AACrB;AACA,mCAAmC,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC5F,uCAAuC,cAAc,EAAE","sourcesContent":["/* C10 preparation: full-width parties/dates/items, notes beside one draft total. */\n.rcti-editor-shell .rcti-prepare-page .invoice-editor-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-editor-column {\n  display: contents;\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  :is(.rcti-prepare-parties, .rcti-prepare-dates, .invoice-items-editor, .rcti-editor-settlement, .invoice-payment-card) {\n  grid-column: 1 / -1;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-flow-card {\n  min-width: 0;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  padding: var(--space-6);\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-flow-card h2 {\n  font-size: var(--font-size-body-lg);\n  font-weight: var(--font-weight-medium);\n  margin: 0 0 var(--space-4);\n}\n.rcti-editor-shell .rcti-prepare-page {\n  --rcti-field-label-gap: 6px;\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  .invoice-flow-card\n  label:not(.rcti-prepare-declaration-check):not(.quotation-attachment-upload) {\n  gap: var(--rcti-field-label-gap);\n}\n.rcti-editor-shell .rcti-prepare-page .figma-datepicker__label {\n  margin-bottom: var(--rcti-field-label-gap);\n  line-height: 18.2px;\n}\n.rcti-prepare-state {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  margin: var(--space-6) 0;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-prepare-state > div {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n}\n.rcti-prepare-state > button {\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  padding: var(--space-3) var(--space-4);\n  font: inherit;\n}\n.rcti-prepare-parties {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: var(--space-6);\n  row-gap: var(--space-3);\n}\n.rcti-prepare-parties > h2,\n.rcti-prepare-parties > .invoice-fields {\n  grid-column: 1 / -1;\n}\n.rcti-prepare-parties .invoice-fields {\n  align-items: start;\n  margin: 0;\n}\n.rcti-prepare-agreement {\n  display: grid;\n  gap: var(--space-2);\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  align-content: start;\n}\n.rcti-prepare-parties .invoice-fields > label {\n  grid-column: 1;\n  grid-row: 1;\n}\n.rcti-prepare-contact {\n  grid-column: 1;\n  grid-row: 3;\n  display: grid;\n  gap: var(--space-2);\n  align-self: start;\n}\n.rcti-prepare-parties > .invoice-fields {\n  display: contents;\n}\n.rcti-prepare-parties > h2 {\n  grid-row: 1;\n}\n.rcti-prepare-parties > .invoice-fields > label {\n  grid-row: 2;\n}\n.rcti-prepare-parties .rcti-prepare-agreement {\n  grid-row: 2 / span 2;\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  :is(.rcti-prepare-agreement, .rcti-prepare-contact)\n  p {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-prepare-buyer,\n.rcti-prepare-declaration {\n  grid-column: 1 / -1;\n  margin: var(--space-2) 0 0;\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n.rcti-editor-shell .rcti-prepare-page a {\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  :is(.rcti-prepare-reference, .rcti-prepare-tools) {\n  margin-top: var(--space-4);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-reference {\n  display: grid;\n  gap: var(--space-4);\n}\n.rcti-prepare-reference h3,\n.rcti-prepare-extra-note h3 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-items-editor {\n  display: grid;\n  gap: var(--space-4);\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-item-heading,\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item {\n  display: grid;\n  grid-template-columns: minmax(200px, 1fr) 64px 120px 100px 96px 32px;\n  gap: var(--space-3);\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-item-heading {\n  margin: 0;\n  align-items: center;\n  border-radius: var(--radius-sm);\n  background: var(--surface-secondary);\n  padding: var(--space-3) 0;\n  font-size: var(--font-size-caption-md);\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-item-heading > span:first-child {\n  padding-left: var(--space-3);\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-item-heading > span:nth-child(5) {\n  text-align: right;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item {\n  padding: var(--space-4) 0;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle);\n  border-radius: 0;\n  background: transparent;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-picker {\n  grid-column: 1;\n  grid-row: 1;\n  min-width: 0;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-description {\n  grid-column: 1 / -1;\n  grid-row: 2;\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  .invoice-edit-item\n  > input[aria-label^=\"Quantity\"] {\n  grid-column: 2;\n  grid-row: 1;\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  .invoice-edit-item\n  > input[aria-label^=\"Unit price\"] {\n  grid-column: 3;\n  grid-row: 1;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .rcti-line-tax {\n  grid-column: 4;\n  grid-row: 1;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > strong {\n  grid-column: 5;\n  grid-row: 1;\n  align-self: center;\n  text-align: right;\n  font-size: var(--font-size-body-sm);\n  font-family: var(--font-family-mono);\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  .invoice-edit-item\n  .invoice-rcti-row-actions {\n  grid-column: 6;\n  grid-row: 1;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-type {\n  grid-column: 1;\n  grid-row: 3;\n  width: 140px;\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-value {\n  grid-column: 1;\n  grid-row: 3;\n  margin-left: 152px;\n  width: 140px;\n}\n.rcti-editor-shell .rcti-prepare-page .quotation-items-table-body.is-scrollable {\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n.rcti-editor-shell .rcti-prepare-page\n  :is([id^=\"rcti-prepare-\"], #rcti-buyer-declaration) {\n  scroll-margin-top: calc(var(--app-topbar-height, 64px) + var(--space-4));\n}\n.rcti-prepare-notes {\n  grid-column: 1;\n  grid-row: 4;\n  display: grid;\n  gap: var(--space-4);\n}\n.rcti-prepare-notes > section {\n  padding: 0;\n  border: 0;\n  box-shadow: none;\n  background: transparent;\n}\n.rcti-prepare-notes .invoice-notes-fields {\n  grid-template-columns: 1fr;\n}\n.rcti-prepare-notes .quotation-attachment-summary {\n  padding: var(--space-3);\n}\n.rcti-prepare-total {\n  grid-column: 2;\n  grid-row: 4;\n  position: static !important;\n  display: grid;\n  gap: var(--space-3);\n  padding: var(--space-6);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n}\n.rcti-prepare-total > .invoice-summary-card {\n  border: 0;\n  padding: 0;\n  box-shadow: none;\n}\n.rcti-prepare-total > p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-draft-total-actions {\n  display: grid;\n  gap: var(--space-3);\n  margin-top: var(--space-4);\n}\n.rcti-draft-total-actions > button {\n  width: 100%;\n}\n@media (max-width: 1100px) {\n  .rcti-editor-shell .rcti-prepare-page .invoice-item-heading,\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item {\n    grid-template-columns: minmax(180px, 1fr) 56px 100px 84px 96px 32px;\n  }\n}\n@media (max-width: 1100px) {\n  .rcti-editor-shell .rcti-prepare-page .invoice-editor-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-prepare-notes,\n  .rcti-prepare-total {\n    grid-column: 1;\n    grid-row: auto;\n  }\n  .rcti-prepare-parties {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-prepare-parties .rcti-prepare-agreement {\n    grid-column: 1;\n    grid-row: 4;\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-item-heading {\n    display: none;\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-picker {\n    grid-column: 1 / -1;\n    grid-row: 1;\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item .item-description {\n    grid-row: 2;\n  }\n  .rcti-editor-shell\n    .rcti-prepare-page\n    .invoice-edit-item\n    > input[aria-label^=\"Quantity\"] {\n    grid-column: 1;\n    grid-row: 3;\n  }\n  .rcti-editor-shell\n    .rcti-prepare-page\n    .invoice-edit-item\n    > input[aria-label^=\"Unit price\"] {\n    grid-column: 2;\n    grid-row: 3;\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .rcti-line-tax {\n    grid-column: 3;\n    grid-row: 3;\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > strong {\n    grid-column: 4;\n    grid-row: 3;\n    font-size: var(--font-size-caption-md);\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-type {\n    grid-column: 1 / 3;\n    grid-row: 4;\n    width: auto;\n  }\n  .rcti-editor-shell .rcti-prepare-page .invoice-edit-item > .discount-value {\n    grid-column: 3 / 5;\n    grid-row: 4;\n    margin: 0;\n    width: 100%;\n  }\n  .rcti-editor-shell\n    .rcti-prepare-page\n    .invoice-edit-item\n    .invoice-rcti-row-actions {\n    grid-column: 4;\n    grid-row: 5;\n  }\n}\n\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-total {\n  grid-column: 2;\n  grid-row: 4;\n  max-height: none;\n  overflow: visible;\n  position: static;\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-notes {\n  grid-column: 1;\n  grid-row: 4;\n}\n@media (max-width: 1100px) {\n  .rcti-editor-shell .rcti-prepare-page .rcti-prepare-total,\n  .rcti-editor-shell .rcti-prepare-page .rcti-prepare-notes {\n    grid-column: 1;\n    grid-row: auto;\n  }\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-notes > section,\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-total > section {\n  border: 0;\n  box-shadow: none;\n  padding: 0;\n  background: transparent;\n}\n.rcti-editor-shell .rcti-prepare-page p {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  .rcti-prepare-contact\n  > :is(strong, span) {\n  font-size: var(--font-size-body-sm);\n}\n.rcti-editor-shell\n  .rcti-prepare-page\n  .rcti-prepare-notes\n  .invoice-notes-fields {\n  grid-template-columns: minmax(0, 1fr);\n}\n.rcti-prepare-tax-rate {\n  display: flex;\n  gap: var(--space-4);\n  align-items: end;\n}\n.rcti-prepare-tax-rate > label {\n  width: min(300px, 100%);\n}\n.rcti-prepare-tax-rate p {\n  flex: 1;\n  margin: 0 0 var(--space-3);\n}\n.rcti-prepare-extra-note { display: grid; gap: var(--space-3); }\n@media (max-width: 1100px) {\n  .rcti-prepare-tax-rate {\n    flex-direction: column;\n    align-items: start;\n  }\n  .rcti-prepare-tax-rate p {\n    margin: 0;\n  }\n}\n.rcti-editor-shell .rcti-prepare-page .invoice-editor-header p span {\n  color: var(--text-secondary);\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts {\n  display: flex;\n  grid-column: 1 / -1;\n  grid-row: 3;\n  gap: var(--space-3);\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts > label {\n  width: 148px;\n  min-width: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  align-content: start;\n  gap: var(--rcti-field-label-gap);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-adjustment-card > textarea {\n  margin-top: var(--rcti-field-label-gap);\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts .discount-type,\n.rcti-editor-shell .rcti-prepare-page .rcti-line-discounts .discount-value {\n  grid-column: 1;\n  width: 100%;\n  min-width: 0;\n  max-width: none;\n  margin: 0;\n}\n@media (max-width: 1100px) {\n  .rcti-editor-shell .rcti-prepare-page .rcti-line-discounts {\n    grid-row: 4;\n  }\n  .rcti-editor-shell .rcti-prepare-page .rcti-line-discounts > label {\n    width: calc(50% - var(--space-2));\n  }\n}\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check { display: inline-flex; align-items: flex-start; gap: var(--space-2); margin-right: var(--space-2); font-size: var(--font-size-body-sm); line-height: 1.65; }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check input { width: 16px; height: 16px; flex: 0 0 16px; margin: 3px 0 0; accent-color: var(--interactive-default); }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-contact { min-width: 0; }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-address { max-width: min(100%, 44ch); white-space: normal; overflow-wrap: anywhere; word-break: normal; }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration { display: grid; grid-template-columns: minmax(0,1fr) auto; align-items: start; gap: var(--space-3); }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check { display: flex; flex-direction: row; align-items: flex-start; margin: 0; min-width: 0; font-weight: var(--font-weight-regular); }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration-check > span { min-width: 0; }\n.rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration > .rcti-business-eligibility-action { align-self: start; line-height: 1.65; }\n@media(max-width:800px) { .rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration { grid-template-columns: minmax(0,1fr); } .rcti-editor-shell .rcti-prepare-page .rcti-prepare-declaration > .rcti-business-eligibility-action { margin-left: 24px; } }\n\n.rcti-editor-shell .rcti-business-eligibility-action {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: var(--interactive-default);\n  font: inherit;\n  line-height: 1.65;\n  text-align: left;\n  cursor: pointer;\n}\n.rcti-editor-shell .rcti-business-eligibility-action:disabled {\n  color: var(--text-disabled, var(--text-secondary));\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rcti-supplier-eligibility-check { display: flex; align-items: center; gap: var(--space-3); }\n.rcti-supplier-eligibility-check svg { flex-shrink: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
